import React, { useContext, useEffect, useState } from 'react'
import { Grid } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { DataGrid, GridCellEditStopReasons } from '@mui/x-data-grid';
import { UiButton } from '../../../_uiComponents/common/form/UiButton';
import { contextApiActions, lookupTableConstants } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import ImportedValidValues from './ImportedValidValues';
import Papa from 'papaparse';
import UiCheckbox from '../../../_uiComponents/common/form/UiCheckBox';
import { useDispatch } from 'react-redux';
import { lookupTableCSVFileUploadRequest, lookupTableListRequest, lookupTableSingleCSVFileUploadRequest, lookupTableValueListRequest } from '../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import { PageLoader, UiFullLoadingSpinner } from '../../../_uiComponents/common/UiLoadingSpinner';
import ImportedValues from './ImportedValues';

export default function AddValuesByFileImport(props) {

    const actionDispatch = useDispatch();
    const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [state, dispatch] = useContext(Context);
    const [firstRowCheck, setFirstRowCheck] = useState(true);
    const [csvFormatedData, setCsvFormatedData] = useState([]);
    const [checkedData, setCheckedData] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loadingFileUploader, setLoadingFileUploader] = useState(false);

    const { lookupTable } = useSelector((state) => {
        return {
            lookupTable: state.lookupTable,
        };
    });
    

    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });

    const columns = [
        {
            field: 'column_name',
            headerName: 'Column Name',
            width: 300,
            type: 'text',
            align: 'left',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,

        },
        {
            field: 'total_records',
            headerName: 'Total Records',
            width: 300,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            hideable: false,
            resizable: false,

        },

    ]

    const processRowUpdate = (newRow, event) => {
        setSelectionModel(csvFormatedData)
    }


    useEffect(() => {
        if (lookupTable?.status) {
            dispatch({
                type: contextApiActions.UI_LARGE_MODAL_TOGGEL,
                payload: {
                    show: true,
                    children:
                        <ImportedValues />
    
                },
            });


        //   actionDispatch(
        //        lookupTableListRequest({
        //             page: 1,
        //             pageSize: 100,
        //        }),
        //   );

          actionDispatch(
            lookupTableValueListRequest({
                 page: 1,
                 pageSize: 5,
                 lookupTableId: props.tableId,
                 search:''
            }),
          );
        }
    }, [lookupTable?.status]);

    const addValuesFileImport = () => {
        let tableDataList = null;
        if(firstRowCheck){
            tableDataList = checkedData.map((column, index) => ({
               // id: column?.id,
                lookupTableId:props?.tableId,
                values: column?.values,
            }))
        }else {
            tableDataList = checkedData.map((column, index) => ({
              //  id: column?.id,
                tableId:props?.tableId,
                values: column?.values,
            }))
        }
        actionDispatch(lookupTableSingleCSVFileUploadRequest({ payload: tableDataList }));
    };

    const csvFileUploader = (data) => {
        setLoadingFileUploader(true);
        const file = data?.target?.files[0];
        if (file?.type === lookupTableConstants.CSV_FILE_TYPE) {
            Papa.parse(file, {
                header: true,
                dynamicTyping: true,
                complete: function (results) {
                    setLoadingFileUploader(false);
                    const columns = results.meta.fields;
                    const rowsData = results.data;

                    const rows = columns.map((column, index) => ({
                        id: index + 1,
                        column_name: column,
                        name: column.replace(/ /g, "_"),
                        formatted_name: column.replace(/ /g, "_"),
                        total_records: rowsData.filter(row => row[column] !== null && row[column] !== undefined).length,
                        values: rowsData.map(row => row[column]).filter(value => value !== null && value !== undefined),
                        active: true,
                        labels: ["string"],
                    }));
                    setTableRows(rows);
                    setCsvFormatedData(rows);

                },
                error: function (error) {
                    console.error('CSV parsing error:', error);
                }
            })
        }
    }

    const handleRowSelectionModelChange = (event) => {
       const filteredObjects = tableRows.filter((object) => {
        const { id } = object;
        return event.some((value) => value === id);
      });
      setCheckedData(filteredObjects);

    };

    const firstRowChecked = (event) => {
        if(event.target.checked){
            setFirstRowCheck(true);
            setTableRows(csvFormatedData);
            setSelectionModel(csvFormatedData)
        }else{
            const rows = tableRows.map((column, index) => ({
                id: index + 1,
                table_name: `table_column_${index + 1}`,
                name: `table_column_${index + 1}`,
                column_name: `table_column_${index + 1}`,
                total_records: column?.total_records,
                values: column?.values,
                active: true,
                labels: ["string"],
            }));
            setTableRows(rows);
            setFirstRowCheck(false)
        }
    }

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 1 }}>
            <PageLoader show={loadingFileUploader} />
                <Grid item xs={12} lg={12} className='sba-create-by-file-import-top-heading'>
                    <Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                    >
                        Upload file
                        <VisuallyHiddenInput
                            type="file"
                            accept=".csv"
                            onChange={(e) => csvFileUploader(e)}
                        />
                    </Button>
                    <p className='sba-csv-upload-comment'>
                        Only CSV (Comma separated values) files are allowed and the file size should not exceed 5MB. </p>
                </Grid>
                {tableRows.length !== 0 &&
                    <>
                        <div className='sba-table-head-instructions'>
                            <UiCheckbox handleChange={(e) => {firstRowChecked(e)}} 
                            checked={firstRowCheck} label="First row is header" />
                            <span className='sba-lookyp-instructions'>
                                To import the values, please select the required column.
                            </span>
                           
                        </div>
                        <Grid item xs={12} lg={12} className='sba-auto-datagrid-tbl'>
                            <DataGrid
                                rows={tableRows}
                                columns={columns}
                                processRowUpdate={processRowUpdate}
                                checkboxSelection
                                onRowSelectionModelChange={(e) => handleRowSelectionModelChange(e)}
                                hideFooterPagination
                                hideFooter
                                selectionModel={selectionModel}
                            />
                        </Grid>
                        </>
                    }
                        <Grid item xs={12} lg={12}>
                            <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                                <UiButton name="Import" disabled={tableRows?.length === 0 || checkedData.length >= 2} variant="contained" size="small" onClick={addValuesFileImport} />
                            </Stack>
                        </Grid>
            </Grid>

        </>
    )
}
